import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import { DataContext, DataMessages, notifyChange, useData, useDataContext } from "../core/hooks/useData";
import { createElement } from "./createElement";
import { ContainerElement, PresenterComponentProps, Element, usePresenter, useContainer, ContainerState, AllElementTypes, ContainerContext, FieldMessages, PresenterMessages, StructureHeading, SubTitle, SubFormElement, FieldRef, ReportElement, ContainerMessages, EventContext } from "./types";
import { broadcast, subscribe, unsubscribe, useChannel } from "../core/hooks/useChannel";
import { closestIndex, getOffsetTopBackTo } from "../core/utils/dom";
import { newID } from "../core/utils/unique";
import { Icon } from "../core/ui/icons";
import { Report, ReportMessages } from "./Report";
import { useFieldChannelID } from "./Field";
import { Modal } from "../core/ui/Modal";
import { isObject } from "rant-utils";

export function Container(props: PresenterComponentProps & {

}) {

	const presenter = usePresenter();
	const data = useData<any>();

	const def = props.def as ContainerElement;

	const lastHeading = presenter.structureHeadings[presenter.structureHeadings.length-1];

	let result;
	if (def.repeat) {

		if (!data.value[def.id]) {
			data.value[def.id] = [];
		}
		const arr = data.value[def.id];

		result = 
			<RepeatingContainer
				items={arr}
				def={def}
				itemName={def.repeat.itemName}
				structureHeading={lastHeading}
			/>;

	} else {
		// NOTE: if data structures change over time can have consequence of e.g. this.value being a string
		// so check that this.value is an object, and if not have to force it to one
		if (!data.value[def.id]) {
			data.value[def.id] = {};
		} else if (!isObject(data.value[def.id])) {
			data.value[def.id] = {};
		}
		const storeTo = data.value[def.id];
		result = <ContainerInstance def={def} storeTo={storeTo} key={def.id} structureHeading={lastHeading} />;

	}

	return (
		result
	);
}

export function RepeatingContainer(props: {
	items: any[],
	def: ContainerElement,
	itemName: string,
	structureHeading: StructureHeading,
}) {

	const data = useData();

	const { items, def } = props;

	const result = [];

	const [refreshToken, refresh] = React.useState("" as any);

	const presenter = usePresenter();
	const parentContainer = useContainer();

	// which if the repeating instances is currently focused
	// NOTE: only applies if this has a summaryReport associated
	const focusedInstanceRef = useRef(-1);


	function deleteIndex(index?: number) {
		if (index === undefined) index = focusedInstanceRef.current;

		const itemToDelete = items[index];

		items.splice(index, 1);

		// run the delete-item event if handler avail
		if (def.events && def.events["delete-item"]) {
			debugger;
			const container = parentContainer.getChildContainer(itemToDelete.containerID)

			const eventContext: EventContext = {
				container: parentContainer,
				dataWindows: [{
					name: "data",
					obj: container.data,
				}],
				def,
				presenter,
				type: "delete-item",
				debugContext: [
					"RepeatingContainer",
					"delete-item"
				]
			}
			for(let a of def.events["delete-item"]) {
				const val = presenter.scriptEngine.run(a.options.script, eventContext, [ { item: itemToDelete } ]);
			}

		}


		
		focusedInstanceRef.current = -1;
		refresh({});

		if (connectedReport && connectedReport.channel) {
			broadcast(connectedReport.channel, {
				type: ReportMessages.SET_FOCUSED_INDEX,
				index: -1,
			});
		}

		// will have to trigger change so things can respond as well
		broadcast(presenter.channelID, {
			type: DataMessages.CHANGE,
		});

		//		data.validate();

	}

	function handleDelete(e: any, deleteFocused?: boolean) {
		const index = closestIndex(e.target, ".delete");
		if (index < 0) return;

		deleteIndex(index);
	}

	const parentPropPath = getParentPropPath(parentContainer);

	useChannel(presenter.channelID, useCallback((msg: any) => {
		if (msg.type === PresenterMessages.GET_REPEATING_CONTAINER) {
			if (msg.prop === parentPropPath + def.id) {
				msg.items = items;
				msg.refresh = refresh;
				msg.cancelled = true;
			}
		}
	}, []));



	
	// when focused instance changes, send off a scroll message just in case the outline needs to be updated
	React.useEffect(() => {
		broadcast(presenter.channelID, {
			type: PresenterMessages.SCROLL,
		});

		// also auto scroll to top of newly focused item
		if (connectedReport) {
			const elContainer = document.getElementById(presenter.channelID + "-container");
			if (elContainer) {
				let yScrollPos: any;

				if (focusedInstanceRef.current >= 0) {
					const elItem = document.getElementById(def.id + "-" + focusedInstanceRef.current) as any;
					if (elItem) {
						yScrollPos = getOffsetTopBackTo(elItem, elContainer);
					}	
				} else {
					// ask the connected report where its top is at
					const msg = {
						type: ReportMessages.GET_TOP,
						top: 0,
						container: elContainer,
					}
					broadcast(connectedReport.channel, msg);
					yScrollPos = msg.top;
				}

				if (yScrollPos !== undefined) {
					setTimeout(() => {
						elContainer.scrollTop = yScrollPos;
					}, 50);	
				}

				// also if instance is just being focused then make sure a change event triggers to get it prepared properly
				if (focusedInstanceRef.current >= 0) {
					broadcast(presenter.channelID, {
						type: DataMessages.CHANGE,
					});
				}

			}
		}
	}, []);

	// is there an associated summary table
	// if so we need to tell it that this repeating container is to be controlled by it
	const [connectedReport, setConnectedReport] = React.useState<{
		def: ReportElement,
		channel: string
	}>();
	React.useEffect(() => {
		if (!def.summaryReport) return;

		// setTimeout(() => {
			// get field details for the report field
			// const msg = {
			// 	type: PresenterMessages.GET_FIRST_FIELD,
			// 	prop: def.summaryReport,
			// 	field: undefined,
			// 	channel: "",
			// };
			// broadcast(presenter.channelID + "/all-fields", msg);

			const fReport = parentContainer.getField(def.summaryReport);

			//if (msg.field) {
			if (fReport) {
				// save the report details of what connected to
				//const f = msg.field as ReportElement;
				// setConnectedReport({
				// 	def: f,
				// 	channel: msg.channel,
				// });
				setConnectedReport({
					def: fReport.field as ReportElement,
					channel: fReport.channelID,
				});

				// and register with it
				broadcast(fReport.channelID, {
					type: ReportMessages.REGISTER,
					containerChannel: fieldChannelRef.current,
				});

				return () => {
					broadcast(fReport.channelID, {
						type: ReportMessages.UNREGISTER,
					});
				}
			}

		// }, 50);
		
	}, [def.summaryReport]);

	const fieldChannelRef = useFieldChannelID();
	useChannel(fieldChannelRef.current, useCallback((msg: any) => {
		if (msg.type === ReportMessages.SET_FOCUSED_INDEX) {
			focusedInstanceRef.current = msg.index;
			refresh({});

			if (connectedReport) {
				broadcast(connectedReport.channel, msg);
			}

		} else if (msg.type === ReportMessages.DELETE_FOCUSED) {
			deleteIndex();
		}

	}, [fieldChannelRef.current, connectedReport]));

	useChannel(presenter.channelID + "/all-reports", useCallback((msg: any) => {
		if (msg.type === ReportMessages.CLEAR_FOCUSED) {
			focusedInstanceRef.current = -1;
			refresh({});

			if (connectedReport) {
				broadcast(connectedReport.channel, msg);
			}
		}
	}, [connectedReport]));



	for(let i=0;i<items.length;i++) {
		const storeTo = items[i];

		// need to give the containers a unique id so they can be keyed properly and not incorrectly cached in react
		if (!storeTo.containerID) storeTo.containerID = newID();

		let instance = 
			<ContainerInstance
				def={def}
				storeTo={storeTo}
				arrayIndex={i}
				key={storeTo.containerID}
				structureHeading={props.structureHeading}

				isEditing={focusedInstanceRef.current === i}

				repeatingFieldID={fieldChannelRef.current}
			/>
		;

		result.push(
			<div
				className={
					"repeat-instance " 
					+ (presenter.designMode ? "expanded" : "collapsed")
					// + (
					// 	presenter.readOnly ? "collapsed" : 
					// 		(connectedReport ? ((focusedInstanceRef.current === i) ? "expanded" : "collapsed") : "")
					// )
				}
				key={storeTo.containerID}
				id={def.id + "-" + i}
			>
				{instance}  
				
				{/* {
					!presenter.readOnly &&
					// <div className="delete-button-row margin-top-5 flex vert align-end">
						<button
							className="delete"
							data-index={i}
							style={{
								position: "absolute",
								right: "2px",
								bottom: "2px",
							}}
							onClick={handleDelete}
						>Delete {props.itemName}</button>
					// </div>
				} */}
			</div>
		);
	}

	const addTitle = ((items.length >= 1) ? "Add another " : "Add ") + props.itemName;




	return (
		<div className="repeating-container fill">
			<div className="repeating-container-contents">
				{result}
			</div>
			{
				!presenter.readOnly &&
				<div className="add-button">
					<button 
						className="primary"
						onClick={() => {
							items.push({});
							const index = items.length-1;

							focusedInstanceRef.current = index;
							refresh({});

							data.validate();
					
							if (connectedReport && connectedReport.channel) {
								broadcast(connectedReport.channel, {
									type: ReportMessages.SET_FOCUSED_INDEX,
									index,
								});
							}
						}}
					>{addTitle}</button>
				</div>
			}
		</div>
	)

}

function getParentPropPath(parentContainer: ContainerState) {
	if (parentContainer.propPath === undefined) {
		return "";
	} else {
		return parentContainer.propPath;
	}
}

function getPropPath(parentContainer: ContainerState, def: ContainerElement, arrayIndex?: number) {
	let propPath = getParentPropPath(parentContainer);

	if (parentContainer.propPath !== undefined) {
		propPath += def.id;
	}

	if (arrayIndex !== undefined) {
		propPath += "[" + arrayIndex + "]";			
	}

	if (parentContainer.propPath !== undefined) {
		propPath += ".";
	}

	return propPath;
}


export const OptionsContext = createContext({} as any);

export function useOptions() {
	const result = useContext(OptionsContext);
	return result;
}

export function ContainerInstance(props: {
	def: Element,
	storeTo: any,
	arrayIndex?: number,
	structureHeading: StructureHeading,

	isEditing?: boolean,

	repeatingFieldID?: string,
}) {

	const def = props.def as ContainerElement;

	const parentContext = useData();

	// each instance has it's own unique data state
	const data = useDataContext({ initialValue: props.storeTo, parentContext, });

	const presenter = usePresenter();	
	
	const parentContainer = useContainer();

	// options context
	const parentOptions = useOptions();
	const optsFromDef = (def as any).options;
	const extraOptions = useMemo(() => {
		let result = {
			...parentOptions,
		};

		if (optsFromDef) {
	
			try {
				if (optsFromDef.startsWith("{")) {
					// make into expression to get value back
					result = eval("(" + optsFromDef + ")");
				} else {
					result = eval(optsFromDef);
				}
			} catch (e) {
				console.log("Sub form options not valid: " + e);
			}
		}	

		return result
	}, [optsFromDef]);

	// container state
	const propPath = getPropPath(parentContainer, def, props.arrayIndex);
	const container = React.useMemo(() => {
		return {

			parentContainer,

			def,

			data,

			propPath,

			fields: {

			} as any,

			childContainers: [],

			options: extraOptions,

			registerContainer: function(cs: ContainerState) {
				this.childContainers.push(cs);
			},
			unregisterContainer: function(cs: ContainerState) {
				const i = this.childContainers.indexOf(cs);
				if (i >= 0) this.childContainers.splice(i, 1);
			},

			getChildContainer: function(id: string) {
				for(let c of this.childContainers) {
					if (c.data.value.containerID === id) {
						return c;
					}
				}
				return undefined;
			},
		
			// structure,

			registerField: function (props: { field: AllElementTypes, channelID: string }) {
				this.fields[props.field.id] = {
					...props,
					container: this,
				};
			},
			unregisterField: function (field: AllElementTypes) {
				delete this.fields[field.id];
			},

			getField: function(id: string) {
				const ref = this.fields[id];
				return ref;
			},

			find: function(id: string) {
				let parts;
				if (id.indexOf(".") > 0) {
					parts = id.split(".");
				} else {
					parts = [id];
				}

				if (parts.length <= 0) return undefined;

				// // look "up" to get the first part
				// let part = parts[0];
				// let c = this;
				// let currentField: FieldRef;
				// while (c) {
				// 	const result = this.getField(part);
				// 	if (result) {
				// 		currentField = result;
				// 		break;
				// 	}

				// 	c = c.parentContainer!;
				// }

				// if (!currentField!) return undefined;

				// // if we only looking for one part then this is it
				// if (parts.length === 1) return currentField;

				// location the first part

				const containersTraversed: any[] = [];

				function scan(c: ContainerState, prop: string) {
					// is it on this container?
					if (c.getField(prop)) return c;

					containersTraversed.push(c);

					// otherwise check all children
					for(let child of c.childContainers) {
						const found = scan(child, prop) as ContainerState;
						if (found) return found;
					}

					return undefined;
				}
				let c = scan(this, parts[0]);

				if (!c) {
					// try work up through parents
					c = this.parentContainer;
					let found = false;
					while (c && c.childContainers) {
						for(let child of c.childContainers) {
							if (containersTraversed.indexOf(child) >= 0) continue;
							const tmp = scan(child, parts[0]);
							if (tmp) {
								c = tmp;
								found = true;
								break;
							}
						}
						if (found) break;
						
						c = c.parentContainer;
					}
					if (!found) c = undefined;
				}


				if (!c) return undefined;
				

				// otherwise more parts to go...
				// now we have the start, look "down" through fields to find each of the child objects
				// NOTE: the first "childContainer" we will encounter is the one named by the first part, 
				// so in effect starting again in search but with different logic (navigating down through containers)
				// ... we want to walk through the containers until get to the last part
				// ... the last part will be a field on that container
				let currentContainer: ContainerState = c;
				for(let i = 0;i<parts.length-1;i++) {
					const part = parts[i];

					let found = false;
					for(let j=0;j<currentContainer.childContainers.length;j++) {
						const child = currentContainer.childContainers[j];
						if (child.def.id === part) {
							found = true;
							currentContainer = child;
							break;
						}
					}
					if (!found) {
						return undefined;
					}
				}

				// now find the field on this container
				const currentField = currentContainer!.getField(parts[parts.length-1]);
				if (!currentField) return undefined;

				// if we get here then must have found it
				return currentField;

			},

			setVisibility: function(id: string, visible: boolean) {
				const f = this.find(id);
				if (f) {
					broadcast(f.channelID, {
						type: FieldMessages.SET_VISIBILITY,
						visible,
					});
				}
			},

			refresh: function() {
				refreshContainer({});
			}


		} as ContainerState;
	}, [parentContainer, def]);

	if (!presenter.rootContainer) {
		presenter.rootContainer = container;
	}

	const [, refreshContainer] = React.useState({});

	// pass changes from this data state up to presenter and out through form
	React.useEffect(() => {
		presenter.registerDataState(data);

		const sub = subscribe(data.channelName, (msg) => {
			if (msg.type === DataMessages.CHANGE) {
				// prior to making the change broadly known, give the calc fields a chance to update
				// in case there are other things depending on them
				broadcast(presenter.channelID, {
					...msg,
					type: PresenterMessages.RECALC,
				});

				// now broadcast the change
				broadcast(presenter.channelID, msg);
			}

		});

		return () => {
			unsubscribe(data.channelName, sub);

			presenter.unregisterDataState(data);
		};
	}, [presenter, data, def.repeat]);

	// register this container with parent if one exists
	React.useLayoutEffect(() => {
		if (parentContainer && parentContainer.registerContainer) {
			parentContainer.registerContainer(container);

			return () => {
				parentContainer.unregisterContainer(container);
			}
		}
	}, [container, parentContainer]);




	// listen specifically on the channel instance id
	// this is a way for requests to be made of this instance such as "give me your data state"
	useChannel(props.storeTo.containerID, useCallback((msg: any) => {
		if (msg.type === ContainerMessages.GET_REF) {
			msg.data = data;
		}
	}, [props.storeTo.containerID, data]));


	// structure, overview updating
	const subTitle = React.useRef<SubTitle>();
	const isShownInOverview = (def.repeat && def.repeat.overviewTitleProp);
	useChannel(presenter.channelID, useCallback((msg: any) => {
		if (msg.type === DataMessages.CHANGE) {
			if (isShownInOverview) {
				// NOTE: can't assume that the change event is related to overviewTitleProp,
				// it could be a calc field
				if (subTitle.current) {
					const newTitle = data.getValue(def.repeat!.overviewTitleProp!);
					if (newTitle !== subTitle.current.title) {
						subTitle.current.title = newTitle;

						broadcast(presenter.channelID, {
							type: PresenterMessages.STRUCTURE_CHANGE,
						});	
					}
				}
			}

		}
	}, [isShownInOverview, subTitle]));

	// setting up structure if relevant
	React.useEffect(() => {
		const h = props.structureHeading;
		if (isShownInOverview && h) {
			if (!h.subTitles) h.subTitles = [];

			h.repeatingFieldChannelID = props.repeatingFieldID;

			const prop = def.repeat!.overviewTitleProp!;
			const title = data.getValue(prop);
			subTitle.current = {
				title,
				sourceData: data,
				prop: def.id,
				element: instanceRef.current,
			};
			h.subTitles.push(subTitle.current);

			broadcast(presenter.channelID, {
				type: PresenterMessages.STRUCTURE_CHANGE,
			});				

			return () => {
				// clean up from array
				if (h.subTitles) {
					for(let i=0;i<h.subTitles.length;i++) {
						const st = h.subTitles[i];
						if (st.sourceData === data && st.prop === def.id) {
							h.subTitles.splice(i, 1);
							break;
						}
					}
				}

				broadcast(presenter.channelID, {
					type: PresenterMessages.STRUCTURE_CHANGE,
				});				
			}

		}

	}, [props.structureHeading, data, def.id, def.repeat, isShownInOverview, presenter.channelID]);

	let designTag;
	if (presenter.designMode) {
		let name = (def.type === "sub-form") ? "Subform" : "Container";

		if (def.type === "sub-form") {
			name += " - " + (def as any).form;
		}

		if (def.repeat) name += " (repeating)";

		designTag = 
			<div className="tag secondary absolute" style={{top: "-12px", left: "-6px"}}>
				{name}
				{
					(def.type === "container") &&
					<Icon
						type="add" color="white" size="tiny" className="interactive"
						onClick={() => {

							const elementID = newID();
							const newElement = {
								type: "text",
								id: elementID,
								title: elementID,
							};
							if (!container.def.elements) container.def.elements = [];
							container.def.elements.push(newElement as any);
							container.refresh();

						}}
					/>
				}
			</div>;
	}

	const instanceRef = useRef<any>();


	data.validators = [];
	const items: any[] = [];
	if (props.isEditing !== false) {
		if (def.elements) {
			for(let el of def.elements) {
				const item = createElement(el, presenter, data, container);
				if (!item) continue;
	
				items.push(item);
			}
		}	
	}


	const innerContent = (!presenter.designMode && props.isEditing) ? 
		<Modal
			title={"Edit " + def.repeat?.itemName}
			size="width-50vw"
			saveTitle="Close"
			showCancel={false}
			saveOnEnterKey={false}
			onSave={() => {
				// check validation to see if anything is incomplete
				function checkWithin(c: ContainerState) {
					const errs = c.data.validate();
					if (errs.length > 0) return true;

					// child containers
					for(let child of c.childContainers) {
						if (checkWithin(child)) return true;
					}
	
					return false;
				}

				const incomplete = checkWithin(container);
				container.data.setValue("incomplete", incomplete);
				
				broadcast(props.repeatingFieldID!, {
					type: ReportMessages.SET_FOCUSED_INDEX,
					index: -1,
				});

			}}
			showDelete={true}
			onDelete={() => {
				broadcast(props.repeatingFieldID!, {
					type: ReportMessages.DELETE_FOCUSED,
					index: -1,
				});
			}}
		>
			{items}
		</Modal>
	: items;	

	const bg = (def as any).bg;
	const result = (
		<OptionsContext.Provider value={extraOptions}>
			<div
				ref={instanceRef}
				className={"container-instance fill relative " + (bg ? "bg" : "")}
				style={{
					backgroundColor: ((props.isEditing && def.type === "sub-form") ? "rgba(0,0,0,0.1)" : undefined) 

				}}
			>
				{designTag}

				<DataContext.Provider value={data}>
					<ContainerContext.Provider value={container}>
						{innerContent}
					</ContainerContext.Provider>
				</DataContext.Provider>
			</div>
		</OptionsContext.Provider>
	);

	
	return result;
}